export default {
  nav: {
    home: "Inicio",
    login: "Iniciar sesión",
    logout: "Cerrar sesión",
    createProject: "Nuevo proyecto",
  },
  hero: {
    name: "Sergio Penagos",
    role: "Ingeniero de Software · Design Systems · Bilingüe (EN/ES)",
    bio: "Ingeniero de software con experiencia profesional construyendo aplicaciones web escalables, responsivas y accesibles para banca, turismo y salud. Lidero arquitectura frontend con React, Vue, TypeScript y Design Systems escalables, y entrego más rápido integrando flujos de trabajo asistidos por IA (Claude Code, Copilot, Gemini) en mi día a día — sin bajar el nivel de calidad. Bilingüe inglés/español, con experiencia coordinando equipos distribuidos y mentorizando desarrolladores junior.",
    seeCv: "Ver CV",
    viewWork: "Ver mi trabajo",
    hireMe: "Trabaja conmigo",
  },
  timeline: {
    heading: "Sobre mí",
    scrollHint: "Desliza para recorrer todo el camino",
    events: {
      degree2026: {
        date: "Jul 2026",
        title: "Graduado — Ingeniería de Software",
        subtitle: "Grado completado",
        points: [
          "Coroné años de desarrollo de software en producción con fundamentos formales de ingeniería.",
        ],
      },
      globant: {
        date: "Actualmente",
        title: "Globant",
        subtitle: "Ingeniero de Software · Proyecto Sentinel (Edenred)",
        points: [
          "Construyo Sentinel: plataforma de onboarding donde empresas que quieren trabajar con Edenred suben documentos para previsualización, visualización y análisis automatizado.",
          "Flujos de verificación de seguridad: validación de firma legal más chequeos de antecedentes FBI, policía, CIA e Interpol.",
          "Construido con .NET + React usando Arquitectura Hexagonal, Azure AI, contenedores y Kubernetes.",
          "Colaboré en mejoras de SEO y rendimiento; desarrollo asistido por IA en el flujo diario.",
        ],
      },
      britishCouncil: {
        date: "2024 – 2025",
        title: "British Council",
        subtitle: "Ingeniero de Software · Frontend (React/TypeScript)",
        points: [
          "Entregué funcionalidades escalables con React + TypeScript en un equipo totalmente bilingüe (EN/ES).",
          "Diseñé un proceso de resolución de incidentes entre equipos L2 y L3, duplicando la tasa de resolución exitosa.",
          "Monitoreé la salud de producción con dashboards (Datadog) y coordiné el análisis de incidentes complejos.",
          "Mentoricé desarrolladores junior (practicantes de SENA).",
        ],
      },
      helitours: {
        date: "Ago 2024 – Nov 2024",
        title: "Helitours · Freelance",
        subtitle: "Desarrollador Web Senior",
        points: [
          "Lideré el frontend del nuevo sitio de la empresa en WordPress.",
          "Diseñé y personalicé temas con compatibilidad responsiva entre dispositivos.",
          "Introduje prácticas estructuradas de Scrum trabajando directo con stakeholders.",
        ],
      },
      mha: {
        date: "Ago 2024 – Nov 2024",
        title: "Sistema de Monitoreo Hemodinámico (MHA)",
        subtitle: "Desarrollador Web Senior · HealthTech",
        points: [
          "Diseñé un monolito modular con Node.js, React y TypeScript.",
          "Integré datos de dispositivos médicos (custo-30/custo-310) en visualizaciones en tiempo real.",
          "Implementé control de acceso por roles y CRUD completo para usuarios, dispositivos, hospitales y personal.",
          "Desarrollé generación de PDF y reportes.",
        ],
      },
      medellin: {
        date: "Ene 2024 – Ago 2024",
        title: "Medellín Joven",
        subtitle: "Desarrollador Web Senior",
        points: [
          "Diseñé la arquitectura frontend con Angular y TypeScript.",
          "Mejoré el manejo de datos en backend con Node.js y PostgreSQL.",
          "Entrega ágil para una plataforma escalable al servicio de jóvenes ciudadanos.",
        ],
      },
      vass: {
        date: "Jul 2022 – Dic 2023",
        title: "VASS",
        subtitle: "Desarrollador V2 → V1 · Banca & Fintech",
        points: [
          "Desarrollé INTERCAM, plataforma de cumplimiento bancario, con Vue.js + TypeScript.",
          "Construí el sitio privado del banco MIFEL: tarjetas, chequeras, aclaraciones, movimientos y conectividad DIMO.",
          "Desarrollé experiencias públicas y de onboarding para CFG DANDO.",
          "Librería UI custom guiada por Storybook para equipos internacionales multi-idioma.",
        ],
      },
      senaAnalyst: {
        date: "Abr 2020 – Jul 2022",
        title: "Graduado del SENA",
        subtitle: "Tecnólogo en Análisis y Desarrollo de Software",
        points: [
          "Título técnico enfocado en análisis de software, desarrollo y sistemas de información.",
        ],
      },
      dolphin: {
        date: "Mar 2021 – Jun 2021",
        title: "Dolphin Ingeniería S.A.S",
        subtitle: "Desarrollador Web",
        points: [
          "Desarrollé Kairos, app web .NET para gestionar proyectos PRIMAX en la industria de hidrocarburos.",
          "Trabajo de frontend con JavaScript, TypeScript, CSS y Sass.",
        ],
      },
      qoopa: {
        date: "Dic 2019 – Mar 2021",
        title: "Qoopa",
        subtitle: "Desarrollador de Sitios Web",
        points: [
          "Implementé la metodología Scrum en el equipo.",
          "Creé componentes para una librería UI custom con React Native, Vue.js y Styled Components.",
          "Construí sitios interactivos con Laravel y JavaScript moderno.",
        ],
      },
      soul: {
        date: "Abr 2019 – Nov 2019",
        title: "Grupo Soul",
        subtitle: "Desarrollador de Sitios Web (Prácticas)",
        points: [
          "Desarrollé páginas web con HTML, CSS (Bootstrap 4), JavaScript, jQuery, PHP y AJAX.",
        ],
      },
      senaTech: {
        date: "Oct 2018 – Nov 2019",
        title: "Graduado del SENA",
        subtitle: "Técnico en Desarrollo de Software",
        points: [
          "Primer paso formal al desarrollo de software: fundamentos, tecnologías web y práctica de proyecto.",
        ],
      },
      conex: {
        date: "Oct 2017 – Dic 2018",
        title: "Conex Travel",
        subtitle: "Desarrollador de Sitios Web (Medio tiempo)",
        points: [
          "Construí UIs responsivas con React.js y Bootstrap.",
          "Creé componentes reutilizables entre proyectos.",
          "Optimicé bundles reduciendo el peso de archivos y mejorando los tiempos de carga en un 20%.",
        ],
      },
    },
  },
  projects: {
    recentHeading: "Mi Trabajo Reciente",
    otherHeading: "Otros proyectos",
    viewDetails: "Ver detalles",
    goToWeb: "Ir al sitio",
    items: {
      intercambank: {
        description:
          "Plataforma de cumplimiento bancario construida para el banco INTERCAM con un equipo internacional: sitio público multi-idioma sobre CMS Modyo, componentes de librería UI custom y arquitectura de micro-frontends.",
      },
      mifel: {
        description:
          "Sitio privado de banca para el banco MIFEL: gestión de tarjetas, chequeras, aclaraciones, movimientos, cheques, deudas y créditos, además de conectividad con DIMO — multi-idioma y accesible.",
      },
      dando: {
        description:
          "Experiencias públicas, privadas y de onboarding para CFG DANDO, trabajando de cerca con equipos multiculturales de varios países en Vue.js y TypeScript.",
      },
      deone: {
        description:
          "Plataforma de mensajería exprés para PriceSmart Colombia (web + móvil): envío de paquetes y solicitud de servicios, con librería de componentes compartida entre plataformas.",
      },
      kairos: {
        description:
          "Aplicación web .NET para gestionar proyectos PRIMAX en la industria de hidrocarburos: desarrollo de funcionalidades, corrección de errores y mantenimiento general del frontend.",
      },
    },
    other: {
      bbc: {
        description:
          "Sitio web de Bogota Beer Company donde los clientes exploran productos, ofertas, servicios y sedes.",
      },
      stella: {
        description:
          "Sitio de Stella Artois Colombia: productos, ofertas y experiencia de marca para clientes finales.",
      },
      google: {
        description:
          "Clon del landing page de Google con menú de herramientas y versión móvil, hecho con Vue.",
      },
      weather: {
        description:
          "App del clima que consulta pronósticos por ciudad desde una API gratuita usando axios y TypeScript.",
      },
    },
  },
  skills: {
    heading: "Habilidades",
    frontend: "Frontend",
    backend: "Backend & Datos",
    tools: "Herramientas & Plataformas",
    ai: "Ingeniería Asistida por IA",
  },
  services: {
    heading: "Ofertas Freelance",
    cta: "Hablemos",
    hourly: "/h",
    offers: {
      standard: {
        name: "Ingeniería de Software & Consultoría",
        blurb:
          "Entrega completa del producto: arquitectura frontend, Design Systems, APIs, liderazgo de equipo y Scrum — todo lo que tu proyecto necesita.",
      },
      ai: {
        name: "Entrega Potenciada con IA",
        blurb:
          "Mismo alcance, misma calidad — acelerados con flujos Claude Code / Copilot. ¿La quieres más rápido? Paga más.",
      },
    },
  },
  contact: {
    heading: "Contacto",
    lead: "Construyamos algo juntos. Escríbeme por cualquier canal:",
    email: "Correo",
  },
  login: {
    welcome: "Bienvenido",
    hint: "Inicia sesión para gestionar los proyectos del portafolio",
    username: "Usuario",
    password: "Contraseña",
    submit: "Entrar",
    goBack: "Volver",
    invalid: "¡Credenciales inválidas!",
  },
  create: {
    heading: "Crear un nuevo proyecto",
    name: "Nombre",
    namePlaceholder: "Nombre del proyecto",
    description: "Descripción",
    type: "Tipo de proyecto",
    typePlaceholder: "Elige uno",
    url: "URL",
    technologies: "Tecnologías",
    technologiesPlaceholder: "Elige el stack",
    responsibilities: "Responsabilidades",
    tags: "Etiquetas",
    tagsPlaceholder: "Elige algunas",
    images: "Imágenes (máx 10)",
    video: "Video (opcional)",
    submit: "Crear Proyecto",
    submitting: "Creando…",
    success: "Proyecto creado exitosamente",
    failed: "No se pudo crear el proyecto. Inténtalo de nuevo.",
    errors: {
      summary: "Corrige lo siguiente:",
      nameRequired: "El nombre del proyecto es obligatorio",
      descriptionRequired: "La descripción del proyecto es obligatoria",
      typeRequired: "El tipo de proyecto es obligatorio",
      linkRequired: "El enlace del proyecto es obligatorio",
      techMin: "Se requiere al menos una tecnología",
      respRequired: "Las responsabilidades son obligatorias",
      tagsMin: "Se requiere al menos una etiqueta",
      imagesMax: "Máximo 10 imágenes permitidas",
      imagesMin: "Se requiere al menos una imagen",
    },
  },
  detail: {
    about: 'Sobre "{title}"',
    techStack: "Stack Tecnológico",
    evidence: "Evidencia",
    moreDetails: "Más detalles",
    responsibilities: "Responsabilidades",
    topics: "Temas",
    goToSite: "Ir al sitio",
    goHome: "Ir al inicio",
    notFound: "Proyecto no encontrado",
  },
  footer: {
    name: "Jör — Sergio Penagos",
    rights: "Todos los derechos reservados.",
    builtWith: "Hecho con Vue, Flask y demasiado café.",
  },
};
